import i18n from "@/i18n";
import { AdminRoutes } from "@/data/enums/router";
import type { IMenuRoute } from "@/models/routes";

export function bulkOperationsTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_.ticket_operations"),
      to: {
        name: AdminRoutes.CLIENT_TICKET_BULK_OPERATIONS
      }
    }
  ];
}
